import amaLog from '../helpers/log';

export const AD_LOADED_ATTRIBUTE = 'data-aller-ad-loaded';

export const AD_PLACEMENT_ATTRIBUTE = 'data-aller-ad-placement';

export const setAdLoadedForDiv = (divId: string) => {
  amaLog(`Setting ad-loaded attribute for ${divId}`);
  document.getElementById(divId).setAttribute(AD_LOADED_ATTRIBUTE,'');
};
